import type { ClocksState } from '@datadog/js-core/time'
import { combine } from '@datadog/js-core/util'
import type { Context, Observable, BufferedData } from '@datadog/browser-core'
import { noop, ErrorSource, BufferedDataType } from '@datadog/browser-core'
import type { LogsConfiguration } from '../configuration'
import type { LifeCycle } from '../lifeCycle'
import { LifeCycleEventType } from '../lifeCycle'
import { StatusType } from '../logger/isAuthorized'
import { createErrorFieldFromRawError } from '../createErrorFieldFromRawError'

export interface ProvidedError {
  startClocks: ClocksState
  error: unknown
  context?: Context
  handlingStack: string
}

export function startRuntimeErrorCollection(
  configuration: LogsConfiguration,
  lifeCycle: LifeCycle,
  bufferedDataObservable: Observable<BufferedData>
) {
  if (!configuration.forwardErrorsToLogs) {
    return { stop: noop }
  }

  const rawErrorSubscription = bufferedDataObservable.subscribe((bufferedData) => {
    if (bufferedData.type === BufferedDataType.RUNTIME_ERROR) {
      const error = bufferedData.data
      lifeCycle.notify(LifeCycleEventType.RAW_LOG_COLLECTED, {
        rawLogsEvent: combine(
          {
            message: error.message,
            date: error.startClocks.timeStamp,
            error: createErrorFieldFromRawError(error),
            _dd: { debug_ids: error.debugIds },
            origin: ErrorSource.SOURCE,
            status: StatusType.error,
          },
          error.context
        ),
      })
    }
  })

  return {
    stop: () => {
      rawErrorSubscription.unsubscribe()
    },
  }
}
